var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"PanelContent"},[_c('div',{staticClass:"PanelContent__container container"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7170a76f","hasScoped":false,"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/PanelContent/index.vue
// module id = 1325
// module chunks = 2